import { getApiPrefix } from '@/utils/common'

export default {
  insureRecords: '/v3/insurance/pagingInsureRecords',
  buyInsurance: getApiPrefix() + '/gateway'
}
